import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent {
  linkRetry: string = 'https://www.meds.cl'; 
  errorMessage: string = 'Estimado/a, ha ocurrido un problema al procesar el pago.';

  constructor(
    private titleService: Title,
  ) { }

  ngOnInit(): void {
    const estadoCita = localStorage.getItem('estadoCita');
    this.titleService.setTitle('Cursos - MEDS');

    if (estadoCita === 'rejected' || estadoCita === 'approved') {
      this.errorMessage = 'La cita se encuentra pagada o rechazada.';
    }
  }
}